import { datadogRum } from '@datadog/browser-rum';

const trackError = (error, context) => {
  const err = error instanceof Error ? error : new Error(String(error));

  try {
    const hasRumContext = typeof datadogRum?.getInternalContext === 'function'
      ? Boolean(datadogRum.getInternalContext())
      : true;
    if (hasRumContext) {
      datadogRum.addError(err, context);
    }
  } catch (_) {
    // ignore
  }
};

export default trackError;
